import { strapiImageGetters } from './strapiImageGetters'
import type {
  StrapiArticleSummaryList,
  StrapiMagazineArticleCategory,
} from '~/composables/types/strapi/strapi-magazine'

const getId = (
  articleCategory: StrapiMagazineArticleCategory
): number | null => {
  return articleCategory?.id || null
}

const getSlug = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.slug || null
}

const getHeaderImage = (articleCategory: StrapiMagazineArticleCategory) => {
  return articleCategory?.attributes?.header_image?.data || null
}

const getHeaderImageUrl = (
  articleCategory: StrapiMagazineArticleCategory,
  format = null
): string | null => {
  return (
    strapiImageGetters.getImageUrl(getHeaderImage(articleCategory), format) ||
    null
  )
}

const getTitle = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.title || null
}

const getArticles = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.articles?.data || null
}

const getDescription = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.description || null
}

const getSeoTitle = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.seo?.metaTitle || null
}

const getSeoImageUrl = (
  articleCategory: StrapiMagazineArticleCategory,
  format = null
): string | null => {
  return (
    strapiImageGetters.getImageUrl(
      articleCategory?.attributes?.seo?.metaImage?.data,
      format
    ) || null
  )
}

const getSeoMetaDescription = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.seo?.metaDescription || null
}

const getCreatedAt = (
  articleCategory: StrapiMagazineArticleCategory
): string | null => {
  return articleCategory?.attributes?.createdAt || null
}

const getSummaryList = (
  articleCategory: StrapiMagazineArticleCategory
): StrapiArticleSummaryList => {
  return articleCategory?.attributes?.summary_list || null
}

export const articleCategoryGetters = {
  getId,
  getSlug,
  getHeaderImage,
  getHeaderImageUrl,
  getTitle,
  getArticles,
  getDescription,
  getSeoTitle,
  getSeoMetaDescription,
  getCreatedAt,
  getSummaryList,
  getSeoImageUrl,
}
